<template>
  <div class="range-date-picker-container">
    <date-range-picker
      ref="rangeDatePicker"
      :maxSpan="{ 'days': 1 }"
      :dateRange="dateRange"
      :locale-data="locale"
      :autoApply="false"
      :ranges="false"
      :date-format="dateFormat"
      :time-picker-increment="1"
      :timePicker="true"
      @update="updateValues">
      <template v-slot:input>
        <div class="input-range-picker-container">
          <span class="date" :class="{ placeholder: isPlaceholder}">
            <i class="fas fa-calendar-alt icon"></i>
            {{datePickerValue}}
          </span>
        </div>
      </template>
    </date-range-picker>
  </div>
</template>

<script>
import _ from 'lodash';
import DateRangePicker from 'vue2-daterange-picker';
import { isWithinInterval } from 'date-fns';
import dateFormatter from '@/utils/dateFormatter';

export default {
  mixins: [dateFormatter],
  props: {
    startPublish: {
      type: [String, Date],
      default: () => '',
    },
    endPublish: {
      type: [String, Date],
      default: () => null,
    },
    allItems: {
      type: Array,
    },
    bannerItemIndex: {
      type: Number,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  components: {
    DateRangePicker,
  },
  watch: {
    startPublish(newValue) {
      this.mapValues(newValue);
    },
  },
  created() {
    this.initDateRange();
  },
  data() {
    return {
      dateRange: {},
      locale: {
        direction: 'ltr',
        format: 'DD-MM-YYYY',
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        firstDay: 1,
        showWeekNumbers: true,
        daysOfWeek: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
        monthNames: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
      },
    };
  },
  computed: {
    datePickerValue() {
      if (this.dateRange.startDate) {
        return `${this.formatDateTime(this.dateRange.startDate)} - ${this.formatDateTime(this.dateRange.endDate)}`;
      }
      return this.placeholder ? this.placeholder : 'กรุณาเลือกช่วงเวลาที่ต้องการเผยแพร่';
    },
    isPlaceholder() {
      return this.datePickerValue === this.placeholder || this.datePickerValue === 'กรุณาเลือกช่วงเวลาที่ต้องการเผยแพร่';
    },
  },
  methods: {
    initDateRange() {
      if (this.startPublish) {
        this.dateRange = {
          startDate: this.startPublish,
          endDate: this.endPublish,
        };
      }
    },
    updateValues(data) {
      let { startDate } = data;
      const { endDate } = data;
      const start = new Date(startDate);
      const end = new Date(endDate);

      if (start > end) {
        startDate = new Date(end.getTime() - 6000);
      }
      this.$emit('update:startPublish', startDate);
      this.$emit('update:endPublish', endDate);
    },
    mapValues(newValue) {
      this.dateRange = {
        startDate: newValue,
        endDate: this.endPublish,
      };
    },
    dateFormat(classes, date) {
      const c = classes;
      if (!classes.disabled) {
        c.disabled = this.isAllocated(date);
      }
      return c;
    },
    isAllocated(date) {
      if (!this.allItems) return false;
      return _.some(this.allItems, (item, itemIndex) => {
        if (itemIndex !== this.bannerItemIndex) {
          return isWithinInterval(
            date, { start: new Date(item.startPublish), end: new Date(item.endPublish) },
          );
        }
        return false;
      });
    },
  },
};
</script>

<style lang="scss">
@import '~vue2-daterange-picker/dist/vue2-daterange-picker.css';
@import '@/assets/scss/variables.scss';

.daterangepicker {
  .drp-selected {
    display: none;
  }
  .btn-success {
    background: $altv-navy;
    border-color: $altv-navy;
    &:focus {
      background: $altv-navy;
      border-color: $altv-navy;
    }
    &:active {
      background: $altv-navy;
      border-color: $altv-navy;
    }
  }
}

.reportrange-text {
  border: 1px solid $gray-300 !important;
  height: 40px;

  display: flex;
  align-items: center;

  min-width: 300px;
}

.placeholder {
  color: $gray-500;
}

.range-date-picker-container {
  .daterangepicker.openscenter {
    top: 100%;
  }
}

@media screen and (max-width: 1440px) {
  .range-date-picker-container {
    .daterangepicker.openscenter {
      top: -20px;
      -webkit-transform: translate(-55%);
      transform: translate(-55%);
    }
  }
}

@media screen and (max-width: 1360px) {
  .range-date-picker-container {
    .daterangepicker.openscenter {
      top: -300%;
      -webkit-transform: translate(-60%);
      transform: translate(-60%);
    }
  }
}

@media screen and (max-width: 1024px) {
  .range-date-picker-container {
    .daterangepicker.openscenter {
      -webkit-transform: translate(-80%);
      transform: translate(-80%);
    }
  }
}

@media screen and (max-width: 768px) {
  .range-date-picker-container {
    .daterangepicker.openscenter {
      top: 100%;
      -webkit-transform: translate(-26%);
      transform: translate(-26%);
    }
  }
}

.input-range-picker-container {
  .icon {
    margin-right: $spacer * 0.25;
  }
}

</style>
